import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBgyAEvgO5UzTDBE5Av8eQTGzyetM23Xzg",
  authDomain: "portfolio-2ca6c.firebaseapp.com",
  projectId: "portfolio-2ca6c",
  storageBucket: "portfolio-2ca6c.appspot.com",
  messagingSenderId: "449947835369",
  appId: "1:449947835369:web:22e53c44ea4d3538904978"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };